import CryptoJS from "crypto-js";


// const SECRET_KEY = CryptoJS.enc.Utf8.parse("MySAMSASecretKey2025MySAMSASecretKey2025"); // ✅ 32 chars
// const IV = CryptoJS.enc.Utf8.parse("SAMSAInitVector1"); // ✅ 16 chars


const SECRET_KEY = CryptoJS.enc.Utf8.parse("MySAMSASecretKey2025AES256Keys!!"); // ✅ 32 chars
const IV = CryptoJS.enc.Utf8.parse("SAMSAInitVector1"); // ✅ 16 chars

export const encryptFileIdValue = (fileId) => {
  const encrypted = CryptoJS.AES.encrypt(fileId.toString(), SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encodeURIComponent(encrypted.toString());
};